import { render, staticRenderFns } from "./AccountSettingNotification.vue?vue&type=template&id=737062bd"
import script from "./AccountSettingNotification.vue?vue&type=script&lang=js"
export * from "./AccountSettingNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports